import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import attachmentsActionCreators from '../../attachments/action-creators';
import trainingPhasesActionsCreators from './training-phases';

const trainingPhasesReportAttachmentsActions = {
  fetchAttachmentsForReport(reportGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('fetchAttachmentsForReport'));
      const data = await ApiService.get(`/api/v1/reports/${reportGuid}/attachments`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(trainingPhasesActionsCreators.setIsLoading('fetchAttachmentsForReport'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.fetchAttachmentsForReportSuccess(data));
      }
    };
  },
  fetchAttachmentsForReportSuccess(attachmentsResponse) {
    return (dispatch) => {
      dispatch(attachmentsActionCreators.pushAttachments(attachmentsResponse.data));
    };
  },
};

export default trainingPhasesReportAttachmentsActions;
